import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, signInWithPopup } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyBlSr9sMrmxpL3DFICUjdza3zUKhcpNBpo",
  authDomain: "wishesgenie-c89d1.firebaseapp.com",
  projectId: "wishesgenie-c89d1",
  storageBucket: "wishesgenie-c89d1.firebasestorage.app",
  messagingSenderId: "45054215603",
  appId: "1:45054215603:web:624e58cb091854ccd3f7c6",
  measurementId: "G-RD2361ZK5C",
};

const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { auth, provider, signInWithPopup };
